import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useDeleteUserAdminMutation } from "../../../store/slice/tradeApi";
import styles from "../admin.module.css";

function DeleteModal({ user, onClose }) {
  const [deleteUserAdmin, { isLoading }] = useDeleteUserAdminMutation();
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    try {
      await deleteUserAdmin(user.id).unwrap();
      onClose();
    } catch (err) {
      setError(err.data?.msg || "Erreur lors de la suppression");
    }
  };

  return (
    <div className={styles.modalContent}>
      <button
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          border: "none",
          background: "none",
          cursor: "pointer",
        }}
        onClick={onClose}
      >
        <FontAwesomeIcon icon={faXmark} size="xl" color="red" />
      </button>

      <h3>Supprimer l'utilisateur</h3>

      <p className={styles.warning}>Attention, cette action est irréversible !</p>

      <p>
        Voulez-vous vraiment supprimer l'utilisateur{" "}
        <strong>{user.alias}</strong> ({user.email}) et toutes ses données
        associées (portfolios, trades, stratégies) ?
      </p>

      {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}

      <div className={styles.modalBtns}>
        <button
          className={styles.btnConfirmDelete}
          onClick={handleConfirm}
          disabled={isLoading}
        >
          {isLoading ? "..." : "Supprimer"}
        </button>
        <button className={styles.btnCancel} onClick={onClose}>
          Annuler
        </button>
      </div>
    </div>
  );
}

export default DeleteModal;
